import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { gsApiV3 } from "../auth/auth";
import {
  getThunkResponse,
  thunkResponse,
  v3PlayerCheckIns,
  v3TeamCheckIns,
  v3Tournaments,
} from "../app/api";
import { getResponse } from "../helpers/JSONapi";

export const getTournamentCheckIns = createAsyncThunk(
  "checkIns/getTournamentCheckIns",
  async (tournamentID, thunkAPI) => {
    const response = getResponse(
      gsApiV3.get,
      `${v3Tournaments}/${tournamentID}/team-check-ins`,
      undefined,
      thunkAPI,
    );
    return response;
  },
);

export const getTournamentPlayerCheckIns = createAsyncThunk(
  "checkIns/getTournamentPlayerCheckIns",
  async (tournamentID, thunkAPI) => {
    const response = getResponse(
      gsApiV3.get,
      `${v3Tournaments}/${tournamentID}/player-check-ins`,
      undefined,
      thunkAPI,
    );
    return response;
  },
);

export const checkInTeam = createAsyncThunk(
  "checkIns/checkInTeam",
  async (teamCheckinID, thunkAPI) => {
    const response = getResponse(
      gsApiV3.put,
      `${v3TeamCheckIns}/${teamCheckinID}/check-in`,
      { data: {} },
      thunkAPI,
    );
    return response;
  },
);

export const checkInPlayer = createAsyncThunk(
  "checkIns/checkInPlayer",
  async (playerCheckinID, thunkAPI) => {
    const response = getResponse(
      gsApiV3.put,
      `${v3PlayerCheckIns}/${playerCheckinID}/check-in`,
      { data: {} },
      thunkAPI,
    );
    return response;
  },
);

export const checkOutTeam = createAsyncThunk(
  "checkIns/checkOutTeam",
  async (teamCheckinID, thunkAPI) => {
    const response = getResponse(
      gsApiV3.put,
      `${v3TeamCheckIns}/${teamCheckinID}/un-check-in`,
      { data: {} },
      thunkAPI,
    );
    return response;
  },
);

export const checkOutPlayer = createAsyncThunk(
  "checkIns/checkOutPlayer",
  async (playerCheckinID, thunkAPI) => {
    const response = getResponse(
      gsApiV3.put,
      `${v3PlayerCheckIns}/${playerCheckinID}/un-check-in`,
      { data: {} },
      thunkAPI,
    );
    return response;
  },
);

const replaceCheckin = (state, action) => {
  state.tournamentTeamCheckIns = state.tournamentTeamCheckIns?.map?.((ttci) => {
    if (ttci.id === action.payload.id) {
      return action.payload;
    } else {
      return ttci;
    }
  });
  state.tournamentPlayerCheckIns = state.tournamentPlayerCheckIns?.map?.(
    (tpci) => {
      if (tpci?.tournamentTeam?.id === action.payload?.tournamentTeam?.id) {
        return { ...tpci, checkedInAt: action.payload?.checkedInAt };
      } else {
        return tpci;
      }
    },
  );
};

const replacePlayerCheckin = (state, action) => {
  const update = state.tournamentPlayerCheckIns?.map?.((tpci) => {
    if (tpci?.id === action.payload?.id) {
      return action.payload;
    } else {
      return tpci;
    }
  });
  state.tournamentPlayerCheckIns = update;
  const playerTeams = update.filter((tpci) => {
    return (
      tpci.tournamentTeam?.id === action.payload?.tournamentTeam?.id &&
      tpci.roundHoleAssignment?.id ===
        action.payload?.roundHoleAssignment?.id &&
      tpci?.checkedInAt
    );
  });
  const playerTeam = playerTeams?.[0] 

  state.tournamentTeamCheckIns = state.tournamentTeamCheckIns?.map?.((ttci) => {
    if (ttci?.tournamentTeam?.id === playerTeam?.tournamentTeam.id && playerTeams.length === ttci?.tournamentTeam?.players?.length) {
      return { ...ttci, checkedInAt: playerTeam.checkedInAt };
    } else if (
      ttci?.tournamentTeam?.id === action.payload?.tournamentTeam?.id
    ) {
      return { ...ttci, checkedInAt: null };
    } else {
      return ttci;
    }
  });
};

const updateTeamCheckIns = (state, action) => {
  state.tournamentTeamCheckIns = action.payload;
};
const updatePlayerCheckIns = (state, action) => {
  state.tournamentPlayerCheckIns = action.payload;
};

//replace all occurences of checkIn with the name of your new slice
export const checkInSlice = createSlice({
  name: "checkIns",
  initialState: {
    tournamentTeamCheckIns: [],
    tournamentPlayerCheckIns: [],
    notifications: [],
    loading: [],
  },
  //be sure to export any reducers on line 65
  reducers: {
    setTournamentCheckIns: updateTeamCheckIns,
    setPlayerCheckIns: updatePlayerCheckIns,
    updateCheckIn: replaceCheckin,
    addNotification: (state, action) => {
      state.notifications.push(action.payload);
    },
    clearNotifications: (state, action) => {
      state.notifications = [];
    },
  },
  extraReducers: {
    ...getThunkResponse(getTournamentCheckIns, updateTeamCheckIns),
    ...getThunkResponse(getTournamentPlayerCheckIns, updatePlayerCheckIns),
    ...thunkResponse(checkInTeam, replaceCheckin, "Team Check In", {}),
    ...thunkResponse(checkOutTeam, replaceCheckin, "Team Check In", {}),
    ...thunkResponse(checkInPlayer, replacePlayerCheckin, "Team Check In", {}),
    ...thunkResponse(checkOutPlayer, replacePlayerCheckin, "Team Check In", {}),
  },
});

export const {
  setTournamentCheckIns,
  updateCheckIn,
  addNotification,
  clearNotifications,
} = checkInSlice.actions;

//export any selectors needed
export const selectTournamentTeamCheckIns = (state) =>
  state?.[checkInSlice.name]?.tournamentTeamCheckIns;
export const selectTournamentPlayerCheckIns = (state) =>
  state?.[checkInSlice.name]?.tournamentPlayerCheckIns;

export const selectNotifications = (state) =>
  state?.[checkInSlice.name]?.notifications;

export const selectLoading = (state) => state?.[checkInSlice.name]?.loading;

export default checkInSlice.reducer;

//ADD reducer to store.js
